import {createAction} from 'typesafe-actions';

import {RunWithSupportedKeys} from '../../../util/runs';
import {Ref as RunSetRef} from '../runSet/types';
import {Ref as TempSelectionsRef} from './types';

export const selectAllVisible = createAction(
  '@view/tempSelections/selectAllVisible',
  action => (ref: TempSelectionsRef, runSetRef: RunSetRef) =>
    action({ref, runSetRef})
);

export const selectNone = createAction(
  '@view/tempSelections/selectNone',
  action => (ref: TempSelectionsRef, runSetRef: RunSetRef) =>
    action({ref, runSetRef})
);

export const selectToggle = createAction(
  '@view/tempSelections/selectToggle',
  action =>
    (
      ref: TempSelectionsRef,
      runSetRef: RunSetRef,
      run: RunWithSupportedKeys,
      depth: number
    ) =>
      action({ref, runSetRef, run, depth})
);

export const selectSome = createAction(
  '@view/tempSelections/selectSome',
  action =>
    (
      ref: TempSelectionsRef,
      runSetRef: RunSetRef,
      runs: RunWithSupportedKeys[]
    ) =>
      action({ref, runSetRef, runs})
);

export const selectAll = createAction(
  '@view/tempSelections/selectAll',
  action => (ref: TempSelectionsRef, runSetRef: RunSetRef) =>
    action({ref, runSetRef})
);
